import h from 'react-hyperscript';
import {TextField, FormControl, Chip} from '@material-ui/core';
import './ChipInput.scss';

export default function ChipInput(props) {
  const {
    value,
    elements,
    handleKeyDown,
    handleChange,
    handleDelete,
    handlePaste,
    error,
    message,
  } = props;

  const chipComponents = elements.map((chip, i) => {
    const errorClass = chip.error ? 'invalid-color' : '';
    return chipRenderer(
        {
          text: chip.value,
          className: `chip-input__chip ${errorClass}`,
          handleDelete: () => handleDelete(chip),
          key: i,
        }
    );
  });

  return (
    h(FormControl, {
      fullWidth: true,
      className: 'chip-input',
    }, [
      h('div', {
        className: 'chip-input__container',
      }, [
        h(chipComponents),
        h(TextField, {
          value: value,
          onChange: handleChange,
          onKeyDown: handleKeyDown,
          onPaste: handlePaste,
          placeholder: 'Add email address',
          helperText: message,
          error: error,
        }),
      ]),
    ])
  );
}

const chipRenderer = ({text, handleDelete, className, key}) => (
  h(Chip, {
    key,
    className,
    onDelete: handleDelete,
    label: text,
    size: 'small',
    color: 'primary',
  })
);
